export default __webpack_public_path__ + "static/staff-photo-2-0af0edf7c0fc23049fb54e2d3fe82403.jpg";